import React, { useState, useEffect, Fragment } from 'react'
import { useQuery } from 'react-apollo-hooks'
import * as Queries from '../recommendedAncillaries/queries'
import styled from 'react-emotion'
import { ShadowBox, Shadow, colors } from '../../styles'
import { Svg, Loader, LinkWithIcon } from '../../application'
import ExcursionPuff from './ExcursionPuff'
import { settings } from '../../resources'
import getText from '../strings'

const Container = styled(ShadowBox)`
  display: flex;
  margin: unset;
  margin-top: -9px;
  width: 100%;
  height: auto;
  padding: 15px 10px;
  border-radius: 4px;
  position: relative;
  background-color: ${colors.tui_beige_50};
  color: ${colors.tui_link_blue};
  flex-direction: column;
  button:focus {
    outline: none !important;
  }
  @media (max-width: 767px) {
    padding: 10px 5px;
  }
`

const Header = styled('h3')`
  color: ${colors.tui_dark_blue};
`

const Toggle = styled('button')`
  display: flex;
  width: inherit;
  height: 30px;
  justify-content: space-between;
  align-items: baseline;
  background: none;
  border: none;
  color: ${colors.tui_dark_blue};
  font-weight: bold;
  font-size: 18px;
  padding: none;
  p {
    margin-top: 2px;
  }
  div {
    display: flex;
    svg {
      margin-left: -10px;
    }
  }
`

const Recommendation = styled('a')`
  display: flex;
  flex-direction: column;
  color: ${colors.tui_dark_blue};
  h4 {
    margin: 0;
    padding: 15px;
  }
  :hover {
    text-decoration: none;
    color: ${colors.tui_dark_blue};
  }
  img {
    max-width: 600px;
  }
  p {
    margin: 0px 15px;
    font-size: 16px;
  }
`

const Flex = styled('div')`
  display: flex;
  flex-wrap: wrap;
  margin: 20px 0px;
  > div:nth-child(4) {
    margin-right: 0;
  }
  @media (max-width: 767px) {
    flex-direction: column;
  }
  @media (max-width: 992px) {
    > div:nth-child(2) {
      margin-right: 0;
    }
  }
`

const ExcursionContainer = styled(Shadow)`
  background-color: ${colors.tui_white};
  width: calc(25% - 8px);
  overflow: hidden;
  margin-top: 10px;
  margin-right: 10px;
  @media (max-width: 992px) {
    width: calc(50% - 5px);
    margin-bottom: 10px;
  }
  @media (max-width: 767px) {
    width: 100%;
    margin-right: 0px;
  }
`

const Prices = styled('div')`
  position: relative;
  bottom: 10px;
  margin-top: 35px;
  margin-right: 10px;
  p {
    margin: 0;
    text-align: right;
  }
`

export default ({ booking, isNextUpcomingTrip }) => {
  const [expanded, setExpanded] = useState(isNextUpcomingTrip)
  const [excursionData, setExcursionData] = useState(null)
  const { loading, data } = useQuery(Queries.getRecommendedExcursions(booking.bookingNumber))
  const isGDNBooking = booking.packageType === 'HOTEL_ONLY'
  const toggleWidget = () => {
    setExpanded(!expanded)
  }
  useEffect(() => {
    if (!loading && data.recommendedExcursions && data.recommendedExcursions.eligibleToBook) {
      setExcursionData(data.recommendedExcursions)
    }
  }, [loading, data])

  const image = (imageUrl) => {
    if (!imageUrl) {
      return <img alt="" src="https://imgix.tuinordic.com/tui-nordic/fallback.jpg?w=400" />
    }
    return <img src={imageUrl.split('?')[0] + '?w=400'} alt="" />
  }

  const getLinkWithoutExcursions = () => {
    if (isGDNBooking && booking.products[0].hotelContact) {
      let cityName = booking.products[0].hotelContact.address.city
      return `${settings.musementTargetUrl}/search?q=${cityName}`
    }
    return `${settings.musementTargetUrl}${excursionData.widgetLink}`
  }

  String.prototype.trunc = function (n, useWordBoundary) {
    if (this.length <= n) {
      return this
    }
    let subString = this.substr(0, n - 1)
    return (useWordBoundary ? subString.substr(0, subString.lastIndexOf(' ')) : subString) + '...'
  }

  if (loading || !excursionData) return null
  return (
    <Container>
      <Toggle onClick={toggleWidget}>
        <Header>
          <Svg icon="shoe"></Svg>&nbsp;&nbsp;
          {getText('excursion', 'recommendedExcursions')}
        </Header>
        <div>
          <p>
            {expanded ? getText('excursion', 'hideExcursions') : getText('excursion', 'showExcursions')}
            &nbsp;&nbsp;
          </p>
          {expanded ? <Svg icon="chevron-up" /> : <Svg icon="chevron-right" />}
        </div>
      </Toggle>
      {expanded && (
        <>
          {!excursionData.recommendations || excursionData.recommendations.length === 0 ? (
            <Fragment>
              <ExcursionPuff link={getLinkWithoutExcursions()} />
            </Fragment>
          ) : (
            <Fragment>
              <Flex>
                {excursionData.recommendations.map((excursion, index) => {
                  console.log(excursion)
                  return (
                    <ExcursionContainer key={excursion.id}>
                      <Recommendation href={`${settings.musementTargetUrl}${excursion.url}`} target="_blank">
                        <div className="ratio-16-9">{image(excursion.image)}</div>
                        <h4>{excursion.name}</h4>
                        <p>{(excursion.description || '').trunc(150, true)}</p>
                        {excursion.price && excursion.price.adult && (
                          <Prices>
                            <p>
                              <strong>{getText('excursion', 'adults')}</strong> {getText('excursion', 'from')} <strong>{excursion.price.adult.formatted_iso_value}</strong>
                            </p>
                            {excursion.price.child && (
                              <p>
                                <strong>{getText('excursion', 'children')}</strong> {getText('excursion', 'from')} <strong>{excursion.price.child.formatted_iso_value}</strong>
                              </p>
                            )}
                          </Prices>
                        )}
                      </Recommendation>
                    </ExcursionContainer>
                  )
                })}
              </Flex>
              <LinkWithIcon
                icon="chevron-right"
                href={`${settings.musementTargetUrl}${excursionData.widgetLink}`}
                text={getText('excursion', 'showAllExcursions')}
                iconRight
                tracking="excursion-recommendation-showall"
              />
            </Fragment>
          )}
        </>
      )}
    </Container>
  )
}
